<template>
  <header class="site-header">
    <nav class="navbar navbar-expand-lg" data-bs-theme="dark">
      <div class="container-fluid">
        <a
          class="navbar-brand navbar-dark"
          href="/"
          title="SPP Application Portal"
          aria-label="SPP Application Portal"
        >
          <SiteLogoText height="40" />
        </a>
        <EnvBadge />

        <SiteNavigation />
      </div>
    </nav>
  </header>
</template>

<script setup>
import EnvBadge from '@shared/components/EnvBadge.vue'
import SiteNavigation from '@shared/components/SiteNavigation.vue'
import SiteLogoText from './SiteLogoText.vue'
</script>
